import {
  Directive,
  Input,
  HostListener,
  ElementRef,
  DestroyRef,
  inject,
  OnInit,
  Inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { AnalyticsService } from '../analytics.service';
import { DOCUMENT } from '@angular/common';
import { TrackBase } from '../track-base/track-base.directive';

@Directive({
  selector: '[appTrackInput]',
  standalone: false,
})
export class TrackInputDirective extends TrackBase implements OnInit {
  @Input('appTrackInput') fieldName?: string;
  @Input() screenName?: string;
  @Input() debounce = 2000;

  private destroyRef = inject(DestroyRef);
  private valueChange$ = new Subject<string>();

  constructor(
    private el: ElementRef<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    analytics: AnalyticsService,
    @Inject(DOCUMENT) document: Document,
  ) {
    super(analytics, document);

    this.valueChange$
      .pipe(debounceTime(this.debounce), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.trackChange());
  }

  ngOnInit(): void {
    this.resolvedScreenName = this.resolveScreenName(this.screenName);
  }

  @HostListener('focus')
  onFocus() {
    this.trackInteraction('focus');
  }

  @HostListener('blur')
  onBlur() {
    this.trackInteraction('blur');
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.valueChange$.next(value);
  }

  private trackInteraction(type: 'focus' | 'blur') {
    this.track('input_interaction', {
      field_name:
        this.fieldName || this.el.nativeElement.name || 'unknown_field',
      interaction_type: type,
    });
  }

  private trackChange() {
    this.track('input_interaction', {
      field_name:
        this.fieldName || this.el.nativeElement.name || 'unknown_field',
      interaction_type: 'change',
    });
  }
}
